class StoreLocator {
    constructor(section) {
  
      this.el = section;
      this.sectionId = section.dataset.sectionId;
      this.type = section.dataset.sectionType;
      this.data = JSON.parse(section.querySelector('[data-section-data]').innerHTML);
  
      this.selectors = {
        map: '[data-store-locator]',
        byState: '[data-store-locator-by-state]',
        byZip: '[data-store-locator-by-zip]',
        stateOption: '[data-state-option]',
        zipInput: '[data-zip-input]',
        radiusOption: '[data-store-locator-radius]',
        resultHeading: '[data-result-heading]',
        storeResults: '[data-store-results]',
        exclusiveStores: '[data-exclusive-store-results]',
        authorizedStores: '[data-authorized-store-results]',
        resetButton: '[data-store-locator-reset]',
        modal: '[data-store-details-modal]',
        modalStoreName: '[data-store-name]',
        modalOpen: '[data-store-page-modal-open]',
        modalClose: '[data-store-page-modal-close]',
        modalStoreAddresses: '[data-store-address]',
        modalStoreHours: '[data-store-hours]'
      };
  
      this.defaultOptions = {
        lat: this.data.mapCenterLatitude, 
        lng: this.data.mapCenterLongitude,
        zoom: this.data.mapZoom,
        maxZoom: this.data.maxZoom
      }
      this.byState = this.el.querySelector(this.selectors.byState);
      this.stateOption = this.el.querySelector(this.selectors.stateOption);
      this.zipInput = this.el.querySelector(this.selectors.zipInput);
      this.byZip = this.el.querySelector(this.selectors.byZip);
      this.radius = this.el.querySelector(this.selectors.radiusOption);
      this.api_key = this.data.accessToken || 'AIzaSyB5ga__4Kse4OqgO78NOBwopFGq6H_eZjQ';
  
      this.resultHeading = this.el.querySelector(this.selectors.resultHeading);
      this.storeResults = this.el.querySelector(this.selectors.storeResults);
      this.exclusiveStores = this.el.querySelector(this.selectors.exclusiveStores);
      this.authorizedStores = this.el.querySelector(this.selectors.authorizedStores);
      this.resetButtons = [...this.el.querySelectorAll(this.selectors.resetButton)];
  
      this.modal = this.el.querySelector(this.selectors.modal);
      this.modalClose = this.el.querySelector(this.selectors.modalClose);
      this.modalHeading = this.el.querySelector(this.selectors.modalStoreName);
      this.modalAddress = this.el.querySelector(this.selectors.modalStoreAddresses);
      this.modalHours = this.el.querySelector(this.selectors.modalStoreHours);
      
      this.states = [
        {
          code: 'AB',
          name: 'Alberta',
          lat: '55.000000',
          lng: '-115.000000',
        },
        {
          code: 'BC',
          name: 'British Columbia',
          lat: '53.726669',
          lng: '-127.647621',
        },
        {
          code: 'MB',
          name: 'Manitoba',
          lat: '56.415211',
          lng: '-98.739075',
        },
        {
          code: 'NB',
          name: 'New Brunswick',
          lat: '46.498390',
          lng: '-66.159668',
        },
        {
          code: 'NL',
          name: 'Newfoundland and Labrador',
          lat: '53.135509',
          lng: '-57.660435',
        },
        {
          code: 'NT',
          name: 'Northwest Territories',
          lat: '53.000000',
          lng: '-60.000000',
        },
        {
          code: 'NS',
          name: 'Nova Scotia',
          lat: '45.000000',
          lng: '-63.000000',
        },
        {
          code: 'NU',
          name: 'Nunavut',
          lat: '70.453262',
          lng: '-86.798981',
        },
        {
          code: 'ON',
          name: 'Ontario',
          lat: '50.000000',
          lng: '-85.000000',
        },
        {
          code: 'PE',
          name: 'Prince Edward Island',
          lat: '46.250000',
          lng: '-63.000000',
        },
        {
          code: 'QC',
          name: 'Quebec',
          lat: '53.000000',
          lng: '-70.000000',
        },
        {
          code: 'SK',
          name: 'Saskatchewan',
          lat: '55.000000',
          lng: '-106.000000',
        },
        {
          code: 'YT',
          name: 'Yukon Territory',
          lat: '64.000000',
          lng: '-135.000000',
        }
      ];
  
      this._updateMap = this._updateMap.bind(this);
      this._updateByState = this._updateByState.bind(this);
      this._updateByZip = this._updateByZip.bind(this);
      this._reset = this._reset.bind(this);
  
      let { storeGroups } = this.data;
      this.storeLocations = Object.keys(storeGroups).reduce((acc, key, i ) => acc.concat(storeGroups[key]), []).map((store) => {
        const hasHours = store.sun || store.mon || store.tue || store.wed || store.tue || store.fri || store.sat;
        return {
          name: store.n,
          address1: store.a1,
          address2: store.a2,
          city: store.c,
          state: store.s,
          zipcode: store.z,
          lat: store.lat,
          lng: store.lng,
          phone: store.p,
          featured: true,
          hours: hasHours ? {
            Sunday: store.sun,
            Monday: store.mon,
            Tuesday: store.tue,
            Wednesday: store.wed,
            Thursday: store.thu,
            Friday: store.fri,
            Saturday: store.sat
          } : false
        }
      });
  
      this.exclusiveStoreLocations = this.storeLocations.filter(store => store.featured);
      this.authorizedStoreLocations = this.storeLocations.filter(store => !store.featured);
  
      this.mapEl = document.querySelector(this.selectors.map);
  
      if(!this.mapEl) {
        return;
      }
      this._init();
    }
  
    _handleLocationError(browserHasGeolocation, infoWindow, pos) {
      infoWindow.setPosition(pos);
      infoWindow.setContent(
        browserHasGeolocation
          ? "Error: The Geolocation service failed."
          : "Error: Your browser doesn't support geolocation."
      );
      infoWindow.open(map);
    }
  
    /**
     * Called when section instance is created
     */
    _init() {
      // Create the script tag, set the appropriate attributes
      var script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${this.api_key}&callback=initMap`;
      script.defer = true;
  
      // Attach your callback function to the `window` object
      window.initMap = this._initMap.bind(this);
  
      // Append the 'script' element to 'head'
      document.head.appendChild(script);
      this._bindEvents();
      
    }
  
    _bindEvents() {
  
      if(this.byState) {
        this.byState.addEventListener('click', this._updateByState);
      }
  
      if(this.byZip) {
        this.byZip.addEventListener('click', this._updateByZip);
      }
  
      this.resetButtons.forEach(button => {
        button.addEventListener('click', this._reset);
      })
    }
  
  
    _initMap() {
      let center = new google.maps.LatLng(
        this.defaultOptions.lat, 
        this.defaultOptions.lng
      );
  
      this.defaultOptions = Object.assign({}, this.defaultOptions, {
        center: center,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      });
  
      this.geocoder = new google.maps.Geocoder();
      this.map = new google.maps.Map(this.mapEl, this.defaultOptions);
      this.markers = [];
      this._initMarkers();
    }
  
    _initMarkers() {
      this.infoWindow = new google.maps.InfoWindow();
      this.exclusiveStoreLocations.filter(location => location.lat && location.lng).forEach(async (location, i) => {
        
        let marker = new google.maps.Marker({
          position: location,
          map: this.map,
          icon: this.data.markerIcon
        });
  
        this.markers.push({ marker, location });
  
        let content = this._generateInfoWindow(location);
  
        marker.setLabel({color: '#fff', fontSize: '12px', lineHeight: '1', text: `${i+1}`});
        marker.addListener('click', () => {
          this.infoWindow.setOptions({
              content: content,
              maxWidth: 200
          });
          this.infoWindow.open(this.map, marker);
        });
      });
  
      this._fitToMarkers(this.markers.map(m => m.marker));
    }
  
    _generateInfoWindow(location) {
      let phone = location.phone ? `<p class="map-marker__phone">${location.phone}</p>` : ``;
      return `
        <div class="map-marker__info">
          <p class="map-marker__heading">${location.name}</p>
          <p class="map-marker__url"><a target="_blank" href="${this._generateMapUrl(location)}">Directions</a></p>
          ${phone}
        </div>`;
    }
  
    _addressToString(address) {
      let { name, address1, address2, city, state, zipcode } = address;
      return [name, address1, address2, city, state, zipcode ].filter(n => !!n).join(', ');
    }
  
    _generateMapUrl(location) {
      let query = encodeURI(this._addressToString(location));
      return `https://www.google.com/maps/search/?api=1&query=${query}`;
    }
    
    _updateByState(e) {
      e.preventDefault();
      let selected_state = this.stateOption.value;
  
      if(!selected_state) {
        this._reset();
              var stateSelect = document.querySelector('[data-state-option]');
              var notifyError = document.getElementById('notify-state');
  
              notifyError.textContent = 'Please select a state.';
              notifyError.className = 'error';
              notifyError.style.display = 'block';
              stateSelect.className = 'invalid store-locator__select store-locator__select--state';
              stateSelect.setAttribute('aria-invalid', 'true');
  
              stateSelect.addEventListener('change', function (event) {
                  if ('block' === notifyError.style.display) {
                      stateSelect.className = 'store-locator__select store-locator__select--state';
                      notifyError.style.display = 'none';
                      notifyError.className = '';
                      notifyError.textContent = '';
                      stateSelect.setAttribute('aria-invalid', 'false');
                  }
              });
        return;
      }
  
      let state = this.states
        .find(state => state.code == selected_state);
  
      if(!state) {
        this._reset();
        return;
      }
  
      let whole_country = this.radius.querySelector(`${this.selectors.radiusOption} option[label=Nationwide]`).value;
      this.geocoder.geocode(
        { 'address' : this._addressToString(state) }, 
        this._updateMap.bind(
          this,
          whole_country,
          () => this.storeLocations.filter(location => location.state === selected_state), 
          this._includesStore.bind(this, ['state']))
      );
    }
  
    _updateByZip(e) {
      e.preventDefault();
  
      let zip = this.zipInput.value;
  
      if(!zip) {
        this._reset();
        var zipInput = document.querySelector('[data-zip-input]');
              var notifyError = document.getElementById('notify-zip');
  
              notifyError.textContent = 'Please enter a zip code.';
              notifyError.className = 'error';
              notifyError.style.display = 'block';
              zipInput.className = 'invalid store-locator__zip form__field form__field--text is-filled';
              zipInput.setAttribute('aria-invalid', 'true');
  
              zipInput.addEventListener('input', function (event) {
                  if ('block' === notifyError.style.display) {
                      zipInput.className = 'store-locator__zip form__field form__field--text is-filled';
                      notifyError.style.display = 'none';
                      notifyError.className = '';
                      notifyError.textContent = '';
                      stateSelect.setAttribute('aria-invalid', 'false');
                  }
              });
        return;
      }
  
  
      let radius = this.radius.value;
      this.geocoder.geocode(
        { 
          'address' : zip,
          'componentRestrictions': {
            'country': 'CA'
          }
        },
        this._updateMap.bind(
          this, 
          radius, 
          (coords, radius) => this._closestStores(coords, radius),
          this._includesStore.bind(this, ['lat', 'lng'])) 
      );
    }
  
    _includesStore(props, store, stores) {
      return !!stores.find(s => props.reduce((acc, prop, i) => acc && store[prop] == s[prop], true));
    }
  
    async _updateMap(radius, getStores, storeFilter, results, status) {
      
      if (status == google.maps.GeocoderStatus.OK) {
        //Got result, center the map and put it out there
        const { location } = await results[0].geometry;
        const { lat, lng } = location;
        const coords = { lat: lat(), lng: lng() };      
        const stores = getStores(coords, radius);
  
        this.markers.forEach(obj => {
          let { marker, location } = obj;
          marker.setVisible(storeFilter(location, stores));
        });
    
        let visibleMarkers = this.markers.map(m => m.marker).filter(m => m.getVisible());
        visibleMarkers.forEach(((marker, i) => {
          let { position } = marker;
          let index = stores.map(({ lat, lng }, i) => ({ lat, lng, index: i })).find(({ lat, lng }) => lat === position.lat() && lng === position.lng()).index + 1;
          marker.setLabel({color: '#fff', fontSize: '12px', lineHeight: '1', text: `${index}`});
        }));
        if(visibleMarkers.length) {
          this._fitToMarkers(visibleMarkers);
        }
  
        this._moveToLocation(coords);
        this._renderResults(stores);
      } else {
        alert("Geocode was not successful for the following reason: " + status);
      }
    }
  
    _renderResults(stores) {
      const { length } = stores;
  
      if (length == 0) {
        const resetBottomButton = document.querySelector('.store-locator__reset-wrapper--bottom');
        resetBottomButton.style.display = 'none';
      }
  
      this.el.classList.add('store-locator--results');
      this.el.classList.toggle('store-locator--zero-results', !length);
      this.resultHeading.innerText = `We Found ${length} store${length != 1 ? 's' : ''}`;
      let exclusiveStores = stores.filter(store => store.featured);
      let authorizedStores = stores.filter(store => !store.featured);
  
      this._renderExclusiveStores(stores);
      this._renderAuthorizedStores(authorizedStores);
  
      // window.initEasyToggleState();
    }
  
    _renderExclusiveStores(stores) {
      this.exclusiveStores.parentElement.classList.toggle('store-locator__results--no-exclusive', !stores.length);
      this.exclusiveStores.innerHTML = '';
  
      if(!stores.length) {
        return;
      }
  
      let storeFragment = document.createDocumentFragment();
  
      let storesFragment = stores.reduce((fragment, store) => {
        let li = document.createElement('li'),
            info = document.createElement('address'),
            cta = document.createElement('div');
        Object.assign(li, { className: 'exclusive-store' });
        Object.assign(info, { className: 'exclusive-store__info' });
        Object.assign(cta, { className: 'exclusive-store__cta-wrapper' });
  
        cta.innerHTML = `<modal-opener data-modal="#modal-store-details"><button class="exclusive-store__cta" aria-haspopup="dialog" type="button" data-toggle-class data-toggle-target="#modal-store-details" data-store-page-modal-open>Store Page</button></modal-opener>`;
        
        let name = this._renderOptionalElement('p', store.name, { className: 'exclusive-store__heading' }), 
            address = this._renderOptionalElement('p', [store.address1, store.address2].join(', ')), 
            area = this._renderOptionalElement('p', [[store.city, store.state].join(', '), store.zipcode].join(' ')), 
            phone = this._renderOptionalElement('p', store.phone),
            distance = this._renderOptionalElement('p', store.distance ? `About ${Math.round(store.distance)} Miles Away` : '', 
            { className: 'exclusive-store__distance'});
  
        let attributes = [name, address, area, phone, distance].filter(attr => attr);
  
        if(attributes.length) {
          attributes = [...attributes, cta];
          attributes.forEach(el => {
            storeFragment.appendChild(el);
          });
  
          cta.children[0].addEventListener('click', this._renderStoreModalContent.bind(this, store));
        }
  
        info.appendChild(storeFragment);
        li.appendChild(info);
        fragment.appendChild(li);
  
        return fragment;
      }, document.createDocumentFragment());
  
      this.exclusiveStores.appendChild(storesFragment);
    }
  
    _renderStoreModalContent(store, e) {
      e.preventDefault();
      
      this.modalAddress.innerHTML = '';
      this.modalHours.innerHTML = '';
      let addressFragment = document.createDocumentFragment();
  
      let name = this._renderOptionalElement('p', store.name, { className: 'store-details__store-name' }), 
          address = this._renderOptionalElement('p', [store.address1, store.address2].join(', ')), 
          area = this._renderOptionalElement('p', [[store.city, store.state].join(', '), store.zipcode].join(' ')), 
          phone = this._renderOptionalElement('p', store.phone);
  
      let attributes = [name, address, area, phone].filter(attr => attr);
  
      attributes.forEach(attr => {
        addressFragment.appendChild(attr);
      });
  
      this.modalHeading.innerText = store.name;
      this.modalAddress.appendChild(addressFragment); 
  
      this.modalHours.parentElement.classList.toggle('store-details__hours--no-hours', !store.hours);
  
      if(!store.hours) {
        return;
      }
  
      let hoursFragment = document.createDocumentFragment();
  
      for (let [key, value] of Object.entries(store.hours)) {
        let p = document.createElement('p'),
            day = this._renderOptionalElement('span', key),
            hours = this._renderOptionalElement('span', value);
        p.appendChild(day);
        p.appendChild(hours);
        hoursFragment.append(p)
      }
  
      this.modalHours.appendChild(hoursFragment);
    }
  
    _renderOptionalElement(tag, content, attributes) {
      if(!tag || !content) {
        return;
      }
  
      let el = document.createElement(tag),
          contentText = document.createTextNode(content);
  
      el.appendChild(contentText);
  
      if(attributes) {
        Object.assign(el, attributes);
      }
  
      return el;
    }
  
    _renderAuthorizedStores(stores) {
      this.authorizedStores.parentElement.classList.toggle('store-locator__results--no-authorized', !stores.length);
      this.authorizedStores.innerHTML = '';
  
      if(!stores.length) {
        return;
      }
  
      this.authorizedStores.innerHTML = stores.map(store => {
        let store_address = [store.address1, store.address2, store.city, store.state, store.zipcode].filter(n=>n);
        let name = store.name ? `<p class="authorized-store__name">${store.name}</p>`: '<p class="authorized-store__name"></p>';
        let address = store_address.length ? `<p class="authorized-store__address">${store_address.join(', ')}</p>`: '<p class="authorized-store__address"></p>';
        let phone = store.phone ? `<p class="authorized-store__phone">${store.phone}</p>`: '<p class="authorized-store__phone"></p>';
        let distance = store.distance ? `<p class="authorized-store__distance">About ${Math.round(store.distance)} Miles Away</p>` : `<p class="authorized-store__distance"></p>`;
  
        return `
          <li class="authorized-store">
            <address class="authorized-store__info">
              ${name}
              ${address}
              ${phone}
              ${distance}
            </address>
          </li>
        `;
      }).join('');    
    }
  
    _reset() {
      this._moveToLocation({
        lat: this.data.mapCenterLatitude, 
        lng: this.data.mapCenterLongitude
      });
      this._clearResults();
    }
    
    _moveToLocation({ lat, lng, zoom = 6 }) {    
      const center = new google.maps.LatLng(lat, lng);
      this.map.panTo(center);
      this.map.setZoom(zoom);
    }
  
    _clearResults() {
      this.el.classList.remove('store-locator--results');
      this.el.classList.remove('store-locator--zero-results');
      this.resultHeading.innerText = ``;
  
      this.stateOption.value = '';
      this.zipInput.value = '';
      this.radius.value = 999999;
  
      this.markers.forEach(obj => {
        let { marker, location } = obj;
        marker.setVisible(true);
        marker.setLabel(null);
      });
  
      this._fitToMarkers(this.markers.map(m => m.marker));
    }
  
    _fitToMarkers(markers) {
  
      var bounds = new google.maps.LatLngBounds();
  
      // Create bounds from markers
      for( var index in markers ) {
          var latlng = markers[index].getPosition();
          bounds.extend(latlng);
      }
  
      // Don't zoom in too far on only one marker
      if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
        var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01);
        var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.01, bounds.getNorthEast().lng() - 0.01);
        bounds.extend(extendPoint1);
        bounds.extend(extendPoint2);
      }
  
      this.map.fitBounds(bounds);
  
      // Adjusting zoom here doesn't work :/
  
    }
  
    /**
     * Calculates the distance between two sets of lat/lng coordinates using the Haversine formula
     * @see https://en.wikipedia.org/wiki/Haversine_formula#Formulation
     * @param {object} pointA An object with `lat` and `lng` number attributes
     * @param {object} pointB An object with `lat` and `lng` number attributes
     * @param {boolean} [milesInsteadOfKm] Use imperial over metric because the US sucks at measuring
     * @returns {number} The distance between pointA and pointB
     */
    _distanceBetweenPoints (pointA, pointB, milesInsteadOfKm) {
      // Earth's radius in km or miles
      const earthRadius = milesInsteadOfKm ?  3958.8 : 6371 
      // Shorthand to convert degrees into radians
      const rad = x => (x * Math.PI) / 180
      // Calculate the Haversine distance
      return 2 * earthRadius * Math.asin(
        Math.sqrt(
          (Math.pow(Math.sin(rad(pointA.lat - pointB.lat)) / 2, 2))
          + 
          (
            Math.cos(rad(pointA.lat)) 
            * Math.cos(rad(pointB.lat)) 
            * (Math.pow(Math.sin(rad(pointA.lng - pointB.lng)) / 2, 2)))
          )
        )
    }
  
    /**
     * Return an array of store objects within a certain distance sorted from closest to futhest
     * @param {object} currentPos 
     * @param {number} maxDistanceMiles 
     * @returns {array} A sorted array of qualifying store objects w/ distance attribute added
     */
    _closestStores (currentPos, maxDistanceMiles) {
      return this.storeLocations
        .map(store => {
          return {
            ...store,
            distance: this._distanceBetweenPoints(currentPos, {lat: store.lat, lng: store.lng}, false)
          }
        })
        .filter(s => { return (s.distance <= maxDistanceMiles) })
        .sort((a, b) => { return a.distance - b.distance })
    }
  }

  customElements.define('store-locator', StoreLocator);
  